import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { AppPageLoading } from '@/shared/components/layout';
import { getPwaStartPath, isPwaStandalone } from '@/shared/lib/pwa';
import LandingPage from './LandingPage';

/**
 * Rota raiz inteligente:
 * - Browser web → landing B2B
 * - PWA instalado → última rota do app ou /login
 * - Sessão ativa → painel correspondente
 */
export default function RootRoute() {
  const { session, role, loading } = useAuth();

  if (loading) return <AppPageLoading />;

  if (session && role === 'super_admin') {
    return <Navigate to="/admin-master" replace />;
  }

  if (session && role === 'tenant') {
    return <Navigate to="/dashboard" replace />;
  }

  if (isPwaStandalone()) {
    const saved = getPwaStartPath();
    if (saved) {
      return <Navigate to={saved} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <LandingPage />;
}
